import { useContext } from 'react';
import TutorialContext from '../contexts/TutorialContext';

// Hook sécurisé qui peut être utilisé même en dehors du TutorialProvider
export const useSafeTutorial = () => {
  try {
    const context = useContext(TutorialContext);
    if (context) {
      return context;
    }
  } catch (error) {
    // Ignore l'erreur si le contexte n'est pas disponible
  }
  
  // Retourner des valeurs par défaut si le contexte n'est pas disponible
  return {
    isActive: false,
    currentStep: 0,
    isCompleted: false,
    hasSeenTutorial: true, // Considérer comme déjà vu si pas de contexte
    steps: [],
    currentStepData: null,
    totalSteps: 0,
    startTutorial: () => {},
    stopTutorial: () => {},
    nextStep: () => {},
    prevStep: () => {},
    goToStep: () => {},
    resetTutorial: () => {},
    shouldShowTutorial: () => false,
    isFirstStep: true,
    isLastStep: true,
    progress: 0
  };
};

export default useSafeTutorial;